import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { DashboardCards } from "@/components/dashboard/DashboardCards";
import { ActivitySection } from "@/components/dashboard/ActivitySection";
import { SidebarInset, SidebarTrigger } from "@/components/ui/sidebar";
import { BarChart3 } from "lucide-react";

export default function Dashboard() {
  const { user } = useAuth();
  const [isAgendaExpanded, setIsAgendaExpanded] = useState(false);
  
  const getUserDisplayName = () => {
    if (user?.email) {
      return user.email.split('@')[0];
    }
    return 'Usuário';
  };

  return (
    <SidebarInset className="flex-1">
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
          <div className="flex items-center gap-2">
            <BarChart3 className="h-5 w-5" />
            <h1 className="font-semibold">Painel</h1>
          </div>
        </header>
        <main className="flex-1 flex flex-col min-h-[calc(100vh-4rem)]">
          <div className="flex-1 bg-background flex flex-col justify-center">
            <div className="container mx-auto p-6 space-y-8">
              {/* Header */}
              <div className="space-y-2" data-tour="dashboard-header">
                <p className="text-muted-foreground font-lato">
                  Bem-vindo de volta, {getUserDisplayName()}
                </p>
                <h1 className="text-4xl font-bold text-foreground font-inter">
                  Ganhe tempo usando as ferramentas abaixo
                </h1>
              </div>

              {/* Main Action Cards */}
              <DashboardCards onAgendaToggle={() => setIsAgendaExpanded(!isAgendaExpanded)} />

              {/* Agenda Expandida */}
              {isAgendaExpanded && (
                <div className="w-full animate-fade-in">
                  <ActivitySection />
                </div>
              )}
            </div>
          </div>
        </main>
      </SidebarInset>
  );
}